import { call, put, delay } from "redux-saga/effects";
import { ordersApi } from "@services/api";
import { getDetailOrderActions } from "../slices";

function* getDetailOrderWorker({ payload }) {
  yield delay(300);
  try {
    yield put(getDetailOrderActions.pending());
    const response = yield call(ordersApi.getDetailOrder, payload);
    yield put(getDetailOrderActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(getDetailOrderActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { getDetailOrderWorker };
